import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card-header align-items-center border-0 mt-4" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "fw-bolder fs-6 text-gray-600 text-uppercase mb-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "w-100 mb-3" }
const _hoisted_6 = { class: "fv-row w-100 text-end" }
const _hoisted_7 = { class: "card-body pt-5" }
const _hoisted_8 = {
  key: 0,
  class: "text-muted fs-8 fst-italic"
}
const _hoisted_9 = { class: "timeline-label" }
const _hoisted_10 = { class: "timeline-label fw-bolder text-gray-800 fs-7" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-primary fs-1" })
], -1)
const _hoisted_12 = { class: "fw-mormal timeline-content ps-3" }
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = { class: "fs-7" }
const _hoisted_15 = { class: "fw-bolder" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "text-center pt-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right ms-1 fs-8" }, null, -1)
const _hoisted_20 = {
  class: "px-2",
  style: {"max-height":"calc(100vh - 3rem)","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_21 = {
  class: "d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom border-gray-200",
  style: {"position":"sticky","top":"0","z-index":"2","background":"var(--bs-body-bg, #fff)"}
}
const _hoisted_22 = { class: "fs-4 fw-bold text-gray-900" }
const _hoisted_23 = { class: "text-muted fs-7" }
const _hoisted_24 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_25 = { class: "timeline-label" }
const _hoisted_26 = { class: "timeline-label fw-bolder text-gray-800 fs-7" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-primary fs-1" })
], -1)
const _hoisted_28 = { class: "fw-mormal timeline-content ps-3" }
const _hoisted_29 = { class: "mb-1" }
const _hoisted_30 = { class: "fs-7" }
const _hoisted_31 = { class: "fw-bolder" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createTextVNode("Ghi chú "),
          (_ctx.arrComment.length != 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_ctx.arrComment.length) + ")", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("textarea", {
          name: "",
          class: "area-custom",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
          id: "",
          style: {"width":"100%"},
          rows: "4",
          placeholder: "Nhập ghi chú..."
        }, null, 512), [
          [_vModelText, _ctx.comment]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: _normalizeClass(["btn btn-sm btn-primary min-w-100px umt-btn-32", _ctx.disableSubmit ? 'disabled' : '']),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitComment && _ctx.submitComment(...args)))
        }, "Thêm ghi chú", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.arrComment.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Chưa có ghi chú nào."))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleComments, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "timeline-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.hhmm), 1),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(item.createdAt) + " - ", 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(item.User?.fullName), 1),
                _createTextVNode(),
                _hoisted_16
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.formatComment(item.comment)) + " ", 1),
              _hoisted_17
            ])
          ]))
        }), 128))
      ]),
      (_ctx.arrComment.length > 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("span", {
              class: "btn btn-sm btn-light-primary umt-btn-32",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAllDrawer = true))
            }, [
              _createTextVNode(" Xem tất cả " + _toDisplayString(_ctx.arrComment.length) + " ghi chú ", 1),
              _hoisted_19
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAllDrawer,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showAllDrawer) = $event)),
      direction: "rtl",
      size: "480px",
      "with-header": false,
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createTextVNode("Ghi chú "),
              _createElementVNode("span", _hoisted_23, "(" + _toDisplayString(_ctx.arrComment.length) + ")", 1)
            ]),
            _createElementVNode("span", {
              class: "btn btn-sm btn-icon btn-active-light-primary flex-shrink-0",
              title: "Đóng",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAllDrawer = false))
            }, [
              _createElementVNode("span", _hoisted_24, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrComment, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "timeline-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(item.hhmm), 1),
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(item.createdAt) + " - ", 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(item.User?.fullName), 1),
                    _createTextVNode(),
                    _hoisted_32
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatComment(item.comment)) + " ", 1),
                  _hoisted_33
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}